var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "gg-card-btn",
      on: {
        click: function click($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c(
        "v-icon",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.icon,
              expression: "icon"
            }
          ],
          attrs: {
            size: _vm.iconSize
          }
        },
        [_vm._v(_vm._s(_vm.icon))]
      ),
      _c(
        "span",
        {
          staticClass: "title"
        },
        [_vm._v(_vm._s(_vm.label))]
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.description,
              expression: "description"
            }
          ],
          staticClass: "description"
        },
        [_vm._v(_vm._s(_vm.description))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }